import React from "react";

const EmptyStatementMsg = (props) => {
  return (
    <div className="empty-statement flex justify-center grow">
      <div className="flex justify-center grow">{props.message}</div>
    </div>
  );
};

export default EmptyStatementMsg;
